export const getCurrentSpecialNote = (state) => {
  return state.pages.projectView.project.specialNotes;
};

export const getEditedSpecialNote = (state) => {
  return state.pages.projectView.modalData.editSpecialNote.editedSpecialNote;
};
